import { inject, observer } from 'mobx-react';
import React from 'react';
import { compose } from 'recompose';
import appConstants from '../../../../../../appConstants';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import { PICKUP_STATUS } from '../../constants';
import CustomConfirmationDialog from '../../DriverPopUp/common/CustomConfirmationDialog';
import {
  unassignPickup,
  assignPickup,
  reassignPickup,
  createAssignPickupDetails
} from '../../utils/pickupActions';
import PickupManagement from '../PickupManagement';
import { PICKUP_MANAGEMENT_MODES } from '../PickupManagement/constants';
import ConfirmationDialogContent from '../PickupManagement/VoidPickupInfo/ConfirmationDialogContent';
import PickupsGridConfig from './GridConfig';
import { getPickupTypes, getSpecialNeedsOptionsWithServiceLevel } from '../../../../utils';
import { getZoneValue } from '../../utils/index';
import { autorun } from 'mobx';
import { isEmpty } from 'lodash/lang';
import { PICKUPS_GRID_FILTERS, DEFAULT_DISPATCH_GRID_FILTER_LIST } from '../Grid/Filter/DEFAULT_constants';
import { NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID } from '../../../../../header/dispatchHeader/Notifications/constants';
import {
  applyPickupReviewDismissAfterNavigate,
  clearColumnFilters,
  findPickupById,
  getToBeReviewedGridFilterOption,
  hasQuickOrColumnFilters,
  isActivePanelFilter,
  isActivePickupGridTab,
  isToBeReviewedHeaderFilter,
  normalizeGroupId,
  scrollPickupIntoView,
  withGroupExpanded,
} from '../../../../../header/dispatchHeader/Notifications/utils';
import Events from '../../../../../../utilities/EventEmitter';
import { withAppConfig } from '../../../../../../appConfigContext';
import { withFeatureFlags } from '../../../../../../userProfile/featureFlagsContext';
import { getDuplicatePickupsByPickupId } from '../../../utils/utils';
import { getFormattedKPIRecommendationData } from '../../Recommendations/common/utils';
import { isMergePickupMode, isBulkPickupMode } from "../PickupManagement/utils";
import {
  getDataWithQueryString,
  postData,
  getDataWithDeduplication
} from '../../../../../../api/componentAPIs';
import {
  PICKUP_ASSIGNMENT_TYPE,
  RECOMMENDATION_MESSAGE,
  RECOMMENDATION_HEADER_NAME,
  DRIVER_RECOMMENDATION_COL_ID
} from '../Grid/headerRenderer/constants';
import {
  getFailedRecommendationAPIMessage,
  getFormattedPickupRecommendations,
  getPayloadForAssignedDriver,
  getPayloadForReAssignedDriver,
  getFormattedPayloadForAssignUnAssignPickups
} from '../Grid/headerRenderer/utils';
import PastPickup from '../PastPickup';
import { withSnackbar } from 'notistack';
import { clearRecommendationKPICache } from '../Grid/cellRenderer/RecommendationRenderer/recommendationCache';
import { RMAXLogger } from '../../../../../../services/LoggerService/RMAXLogger';
import withRouter from '../../../../../../routes/withRouter';
import { cloneDeep, isEqual, uniqBy } from 'lodash';
import { getDriverStopDetails } from '../../ProDetails/PickupProInfo/utils';
import { APP_EVENT_NAMES } from '../../../../../../signalR/constants';
import { withTheme } from '@material-ui/core/styles';
const { DISPATCH } = APP_EVENT_NAMES;
import { isGroupHeaders, isGroupedPickups, getPickupsInGroup, isSingleInGroupPickups } from './utils';
import {
  buildGroupPickupDialogState,
  cloneNavigateStateForHistory
} from '../PickupInfoPopup/groupPickupDialogState';
import { postSortGroupedPickupsRows } from './sortGroupedPickups';
import MapHelper from '../../../../../../lib/Map/Trimble/utils/helper';
import { SelectionManager } from './selection/selectionManager';
import { FilterManager } from './filtering/filterManager';
import { GroupDataManager } from './groupManagement/groupDataManager';
@inject('DispatchStore')
@observer
class GroupPickup extends React.Component {
  constructor(props) {
    super(props);
    this.isRecommendationsEnabled = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.AutomaticPickupRecommendation
    );
    this.gridConfig = new PickupsGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      showStaticRoute: this.props.configJSON?.showStaticRoute,
      pickupPackagingDetailsConfig: this.props.configJSON?.pickupPackagingDetailsConfig,
      featureFlags: {
        enableColumnShortForm: this.props.configJSON?.enableColumnShortForm,
        isRecommendationsEnabled: this.isRecommendationsEnabled
      }
    });

    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.gridApi = {};
    this.state = {
      quickFilterText: '',
      headerFilter: this.props.DispatchStore.pickupsFilter,
      panelFilter: PICKUP_STATUS.unassigned,
      mode: '',
      selectedPossibleMergePickupId: null,
      formattedPickupRecommendations: {},
      isPastPickupOpen: false,
      selectedGroupPickupData: null,
      // Grouping state
      expandedGroups: new Set(),
      loadingUnmergePickup: false,
      openMergeConfirmationDialog: false
    };
    this.priorityShipmentList = this.props.DispatchStore.priorityAllShipmentList;
    this.pickupIdToClosingTimeMapping = this.props.DispatchStore.pickupIdToClosingTimeMapping;
    this.pickupsStatusUpdateTimer = null;
    this.pendingEditPickup = false;
    this.pendingEditPickupId = null; // Store the specific pickup ID for editing
    this.pendingEditPickupAction = null;
    /** Navigate to to-be-reviewed pickup(s) after filter is applied */
    this.pendingNavigateToPickupId = null;
    this.pendingNavigateToPickupIds = null;
    this.pendingNavigateFiltersCleared = false;
    /** Driver-popup bulk edit when pickups are not on the filtered grid — clear store selection on modal close */
    this.clearBulkEditSelectionOnClose = false;
    this.isRecommendationRefreshInProgress = false;
    this.refreshRecommendationTimer = null;
    this.selectionStateSyncTimer = null;
    this.currentPickupDuplicates = [];
    this.isAnyFilterSet = false;
    this.lastSelectedPickupId = null; // Track last selected pickup for shift range
    this.lastSelectedGroupId = null; // Track last selected group for shift range

    // Initialize managers BEFORE gridContext (which references them)
    this.selectionManager = new SelectionManager(this);
    this.filterManager = new FilterManager(this);
    this.groupDataManager = new GroupDataManager(this);

    // Initialize gridContext after managers are created
    this.gridContext = {
      pickupTypeOptions: getPickupTypes(this.props.DispatchStore.pickupPriorityShipmentList),
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.priorityShipmentList),
      terminalOffset: this.props.DispatchStore.terminalOffset,
      newPickupDuration: this.props.configJSON.newPickupDuration,
      handlePossibleMergeClick: this.handlePossibleMergeClick,
      getSelectedPickupsDuplicate: this.getSelectedPickupsDuplicate,
      getClosingSoonPickupTime: this.getClosingSoonPickupTime,
      closingSoonLimitConfig: this.getClosingSoonTimeConfig(),
      handleUnGroupPickupClick: this.handleUnGroupPickupClick,
      // Grouping context
      expanded: this.state.expandedGroups,
      toggle: this.groupDataManager.toggleGroup,
      onGroupClick: this.selectionManager.handleSelection,
      isGroupSelected: this.selectionManager.isGroupSelected,
      // Additional context for group header display
      getZoneValue: getZoneValue
    };
  }
  
  get enablePickupGrouping() {
    return this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupGrouping
    );
  }

  confirmMergePickup = () => {
    const { selectedPickupsList } = this.props.DispatchStore;
    if (this.props.DispatchStore.selectedPickupsList.length > 1) {
      const uniqueShippers = new Set(
        selectedPickupsList.map(pickup => pickup.shipperAddress)
      );
      if (uniqueShippers.size === 1) {
        this.groupDataManager.selectAllPickupsWithSameGroupId();
        this.setState({
          mode: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
          selectedPossibleMergePickupId: null,
          openMergeConfirmationDialog: false
        });
        return;
      }
      const coordinates = selectedPickupsList.map(pickup => [
        pickup.position.lng,
        pickup.position.lat
      ]);
      const distanceInMiles = MapHelper.getGeoMaxDistanceMiles(coordinates);
      const mergeState = {
        mode: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
        selectedPossibleMergePickupId: null,
        openMergeConfirmationDialog: distanceInMiles > 1
      };
      if (distanceInMiles > 1) {
        this.setState(mergeState);
      } else {
        this.groupDataManager.selectAllPickupsWithSameGroupId();
        this.setState(mergeState);
      }
    }
  };


  componentDidMount() {
    this.props.glEventHub.on('pickupManagement', this.openPickupManagement);
    this.props.glEventHub.on('showPickupDetails', this.openPickupDetailsDialog);
    this.props.glEventHub.on(this.gridHeaderId, this.filterManager.onSearchTextChanged);
    this.props.glEventHub.on(`${this.gridHeaderId}_selectFilterSelected`, this.filterManager.headerFilterChanged);
    this.props.glEventHub.on(appConstants.Event.PICKUP_SELECTED_MAP, this.onPickupSelectedOnMap);
    this.props.glEventHub.on('openPastPickup', this.openPastPickup);
    this.props.glEventHub.on(
      NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID,
      this.navigateToToBeReviewedPickup
    );
    Events.on(DISPATCH.DispatchUngroupPickup, this.handleUnmergePickup);
    this.autorunPriorityShipmentList = autorun(() => {
      if (!isEqual(this.priorityShipmentList, this.props.DispatchStore.priorityAllShipmentList)) {
        this.priorityShipmentList = this.props.DispatchStore.priorityAllShipmentList;
        // Update context while preserving grouping functions
        this.gridContext = {
          ...this.gridContext, // Preserve existing context including grouping functions
          terminalOffset: this.props.DispatchStore.terminalOffset,
          pickupTypeOptions: getPickupTypes(this.props.DispatchStore.pickupPriorityShipmentList),
          newPickupDuration: this.props.configJSON.newPickupDuration,
          specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.priorityShipmentList),
          handlePossibleMergeClick: this.handlePossibleMergeClick,
          handleUnGroupPickupClick: this.handleUnGroupPickupClick,
          getSelectedPickupsDuplicate: this.getSelectedPickupsDuplicate,
          getClosingSoonPickupTime: this.getClosingSoonPickupTime,
          closingSoonLimitConfig: this.getClosingSoonTimeConfig(),
          // Preserve grouping functions
          expanded: this.state.expandedGroups,
          toggle: this.groupDataManager.toggleGroup,
          onGroupClick: this.selectionManager.handleSelection,
          isGroupSelected: this.selectionManager.isGroupSelected,
          getZoneValue: getZoneValue
        };
      }
    });
    Events.on('RefreshDuplicatePickups', this.refreshDuplicatePickups);
    Events.on('RefreshPickupRecommendations', this.refreshPickupRecommendations);
    Events.on('EditPickup', this.editPickup);
    this.refreshDuplicatePickups();
    this.groupDataManager.initializeExpandedGroups();
    this.previousGroupMembershipKey = this.groupDataManager.getGroupMembershipKey(
      this.props.DispatchStore.pickupsList
    );
    this.autoRunClosingSoonPickups = autorun(() => {
      if (
        Object.keys(this.pickupIdToClosingTimeMapping).length !==
        Object.keys(this.props.DispatchStore.pickupIdToClosingTimeMapping).length
      ) {
        this.pickupIdToClosingTimeMapping = this.props.DispatchStore.pickupIdToClosingTimeMapping;
        // Only trigger filter change if not in the middle of group selection
        if (!this.isGroupSelectionInProgress) {
          this.gridApi?.onFilterChanged?.();
        }
      }
    });
    this.autoRunPickupFilter = autorun(() => {
      //some time state get pickupsFilter updated before default option set in store
      if (!isEqual(this.state.pickupsFilter, this.props.DispatchStore.pickupsFilter)) {
        this.setAssignedUnassignedRecommendationsFlag(this.props.DispatchStore.pickupsFilter);
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      clearTimeout(this.refreshRecommendationTimer);
      this.setRecommendationColumnVisibility(false);
    }
    if (this.props.featureFlags.featureFlags != prevProps.featureFlags.featureFlags) {
      this.resetRecommendation();
    }

    // pickupsList is a MobX ObservableArray — same reference across replace/splice;
    // compare group membership instead of array identity
    const currentGroupMembershipKey = this.groupDataManager.getGroupMembershipKey(
      this.props.DispatchStore.pickupsList
    );
    if (
      this.previousGroupMembershipKey != null &&
      this.previousGroupMembershipKey !== currentGroupMembershipKey
    ) {
      this.groupDataManager.reinitializeExpandedGroups();
      this.groupDataManager.refreshGridHeaders();
    }
    this.previousGroupMembershipKey = currentGroupMembershipKey;
  }

  componentWillUnmount() {
    this.selectionManager?.dispose?.();
    this.groupDataManager?.dispose?.();
    this.props.glEventHub.off('pickupManagement', this.openPickupManagement);
    this.props.glEventHub.off('showPickupDetails', this.openPickupDetailsDialog);
    this.props.glEventHub.off(this.gridHeaderId, this.filterManager.onSearchTextChanged);
    this.props.glEventHub.off(
      `${this.gridHeaderId}_selectFilterSelected`,
      this.filterManager.headerFilterChanged
    );
    this.props.glEventHub.off(appConstants.Event.PICKUP_SELECTED_MAP, this.onPickupSelectedOnMap);
    this.autorunPriorityShipmentList?.();
    this.autoRunClosingSoonPickups?.();
    this.autoRunPickupFilter?.();
    clearInterval(this.pickupsStatusUpdateTimer);
    this.pickupsStatusUpdateTimer = null;
    Events.off('RefreshDuplicatePickups', this.refreshDuplicatePickups);
    Events.off('RefreshPickupRecommendations', this.refreshPickupRecommendations);
    Events.off('EditPickup', this.editPickup);
    Events.off(DISPATCH.DispatchUngroupPickup, this.handleUnmergePickup);
    clearTimeout(this.refreshRecommendationDelayTimer);
    clearTimeout(this.refreshRecommendationTimer);
    clearTimeout(this.selectionStateSyncTimer);
    this.props.glEventHub.off('openPastPickup', this.openPastPickup);
    this.props.glEventHub.off(
      NAVIGATE_TO_TO_BE_REVIEWED_PICKUP_ON_GRID,
      this.navigateToToBeReviewedPickup
    );
  }

  resetRecommendation = () => {
    this.isRecommendationsEnabled = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.AutomaticPickupRecommendation
    );
    this.lastRefreshRecommendationTime = null;
    this.isManualRecommendationRefresh = false;
    this.showHideRecommendationColumn(this.state.headerFilter);
    if (!this.isRecommendationsEnabled && !isEmpty(this.state.formattedPickupRecommendations)) {
      this.setState({ formattedPickupRecommendations: {} });
    }
  };

  hideRecommendationColumnInShowHideOption = (isInvisibleInShowHide) => {
    const column = this.gridApi.getColumn(DRIVER_RECOMMENDATION_COL_ID);
    if (column?.colDef) {
      column.colDef.isInvisibleInShowHide = isInvisibleInShowHide;
    }
  };

  triggerRefreshRecommendationWithDelay = () => {
    /* when we refresh page/switch terminal existing signalR connection get disconnected and new connection
      will be made, this process took some time, in between if RefreshPickupRecommendations signalR received it wont work.
      assume it will take not more than 3 sec to establish connection again, in worst case if not made user can do manual refresh.
    */
    clearTimeout(this.refreshRecommendationDelayTimer);
    this.resetRefreshRecommendationConfiguration();
    this.refreshRecommendationDelayTimer = setTimeout(() => {
      this.triggerPickupRecommendations();
    }, appConstants.ONE_SECOND_TIME_OUT * 3);
  };

  setRecommendationColumnVisibility = (isVisible) => {
    const column = this.gridApi?.getColumn(DRIVER_RECOMMENDATION_COL_ID);
    if (column && column.isVisible() !== isVisible) {
      this.gridApi?.setColumnsVisible([DRIVER_RECOMMENDATION_COL_ID], isVisible);
    }
  };

  isRecommendationEnabledForValidFilter = (filterOption) => {
    const isValidRecommendationFilter = filterOption.hasOwnProperty(
      'showAssignedUnassignedRecommendations'
    );
    return this.isRecommendationsEnabled && isValidRecommendationFilter; //hide column from eye icon if feature flag is disabled/invalid filter selected for recommendation
  };

  showHideRecommendationColumn = (filterOption, isFilterChanged = false) => {
    const isRecommendationEnabledForValidFilter =
      this.isRecommendationEnabledForValidFilter(filterOption);
    this.hideRecommendationColumnInShowHideOption(!isRecommendationEnabledForValidFilter); //this will show/hide from eye icon only
    const isColumnHiddenByUser = this.isUserPreferenceRecommendationSetHidden(); //even if feature flag is enabled we should also consider user column visibility preference
    if (isColumnHiddenByUser && isRecommendationEnabledForValidFilter) {
      this.triggerPickupRecommendations();
      return;
    }
    this.setRecommendationColumnVisibility(isRecommendationEnabledForValidFilter);
    if (isRecommendationEnabledForValidFilter) {
      this.gridApi.autoSizeColumns([DRIVER_RECOMMENDATION_COL_ID]);
      isFilterChanged
        ? this.triggerPickupRecommendations()
        : this.triggerRefreshRecommendationWithDelay();
    }
  };

  setAssignedUnassignedRecommendationsFlag = (filterOption) => {
    this.showAssignUnassignDriverRecommendation =
      filterOption?.['showAssignedUnassignedRecommendations'];
  };

  resetRefreshRecommendationConfiguration = () => {
    this.refreshDriverRecommendationColumn([]);
    this.lastRefreshRecommendationTime = null;
    this.isRecommendationRefreshInProgress = true;
    this.refreshRecommendationHeader();
  };

  /*
    A. recommendAssignedUnassignedPickups
    1. enable assigned pickup recommendation -> true
    2. enable unassign pickup recommendation -> {A: false
    3. manual pickup refresh -> {A: true/false, B: true}
  */
  triggerPickupRecommendations = async (isManualRefresh = false) => {
    this.isManualRecommendationRefresh = isManualRefresh;
    const payload = {
      terminalCode: this.props.userData.userProfile.terminal.code,
      recommendAssignedPickups: this.showAssignUnassignDriverRecommendation
    };
    try {
      const recommendations = await postData('RefreshRecommendations', payload);
      if (recommendations?.status >= 200 && recommendations.status < 400) {
        this.onRecommendationRefreshTimeOut();
        return;
      }
      const updatedParams = {
        ...payload,
        isManualRefresh,
        recommendAssignedUnassignedPickups: payload.recommendAssignedPickups
      };
      this.onTriggerPickupRecommendationsFailed(updatedParams);
    } catch {
      this.onTriggerPickupRecommendationsFailed(updatedParams);
    }
  };

  refreshRecommendationHeader = () => {
    Events.emit('RefreshRecommendationHeader', {
      time: this.lastRefreshRecommendationTime,
      isDataRefreshProgress: this.isRecommendationRefreshInProgress
    });
  };

  onTriggerPickupRecommendationsFailed = (props) => {
    const apiMessage = getFailedRecommendationAPIMessage(props);
    this.props.enqueueSnackbar(apiMessage, {
      variant: 'error'
    });
    this.isRecommendationRefreshInProgress = false;
    this.refreshRecommendationHeader();
    clearTimeout(this.refreshRecommendationTimer);
  };

  refreshPickupRecommendations = async (data) => {
    if (!this.isRecommendationsEnabled) {
      return;
    }
    Events.emit('SelectedRecommendationChanged');
    clearTimeout(this.refreshRecommendationTimer);
    if (!data?.success) {
      this.onAutoPickupRecommendationRefreshFailed();
      return;
    } else if (data?.areNewRecommendationsAvailable === false) {
      /* in some cases backend wont trigger engine, exa: no pickups are available, all are missed pickups etc. 
        in that cases no sense to call PickupRecommendations api as there wont be any recommendations, we are handling this case suing this flag areNewRecommendationsAvailable
      */
      this.onAutoPickupRecommendationRefreshSuccess([]);
      return;
    }
    try {
      if (!this.isRecommendationRefreshInProgress) {
        this.isRecommendationRefreshInProgress = true;
        this.refreshRecommendationHeader();
      }
      const recommendations = await getDataWithDeduplication(
        'PickupRecommendations',
        `terminalCode=${this.props.userData.userProfile.terminal.code}`
      );
      if (recommendations?.status === 200) {
        this.onAutoPickupRecommendationRefreshSuccess(recommendations.data);
        return;
      }
      this.onAutoPickupRecommendationRefreshFailed();
    } catch {
      this.onAutoPickupRecommendationRefreshFailed();
    }
  };

  onRecommendationRefreshTimeOut = () => {
    clearTimeout(this.refreshRecommendationTimer);
    this.refreshRecommendationTimer = setTimeout(() => {
      if (!this.isRecommendationRefreshInProgress) {
        return;
      }
      this.isRecommendationRefreshInProgress = false;
      this.refreshRecommendationHeader();
      this.props.enqueueSnackbar(
        'Oops! Unable to fetch new recommendations at the moment. Please retry.',
        {
          variant: 'error'
        }
      );
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  refreshDriverRecommendationColumn = (recommendations) => {
    if (recommendations?.length === 0 && isEmpty(this.state.formattedPickupRecommendations)) {
      clearRecommendationKPICache();
      return;
    }
    const formattedPickupRecommendations =
      recommendations?.length > 0
        ? getFormattedPickupRecommendations(recommendations, this.props.DispatchStore.routesList)
        : {};
    this.setState(
      {
        formattedPickupRecommendations
      },
      this.updateDriverRecommendations
    );
  };

  onAutoPickupRecommendationRefreshSuccess = (recommendations) => {
    this.isRecommendationRefreshInProgress = false;
    this.refreshDriverRecommendationColumn(recommendations);
    this.lastRefreshRecommendationTime = new Date();
    this.refreshRecommendationHeader();
    if (this.isManualRecommendationRefresh) {
      this.isManualRecommendationRefresh = false;
      const message =
        recommendations?.length > 0
          ? RECOMMENDATION_MESSAGE.SUCCESS.AUTO_REFRESH_RECOMMENDATION
          : RECOMMENDATION_MESSAGE.SUCCESS.NO_RECOMMENDATION;
      this.props.enqueueSnackbar(message, {
        variant: 'success'
      });
    }
  };

  onAutoPickupRecommendationRefreshFailed = (customMessage = '') => {
    this.isRecommendationRefreshInProgress = false;
    this.isManualRecommendationRefresh = false;
    this.refreshDriverRecommendationColumn([]);
    this.lastRefreshRecommendationTime = null;
    this.refreshRecommendationHeader();
    this.props.enqueueSnackbar(
      customMessage || RECOMMENDATION_MESSAGE.FAILED.AUTO_REFRESH_RECOMMENDATION,
      {
        variant: 'error'
      }
    );
  };

  runCommand = (command, prop) => {
    switch (command) {
      case 'Assign':
        this.assignPickups(prop);
        break;
      case 'Reassign':
        this.reassignPickups(prop);
        break;
      case 'AcceptRecommendations':
        this.assignRecommendations(prop);
        break;
      case 'manualRefreshPickupRecommendations':
        this.resetRefreshRecommendationConfiguration();
        this.triggerPickupRecommendations(true);
        break;
      case 'recommendedDriverByGroupId':
        return this.getRecommendedDriverDetailsByGroupId(prop?.groupId);
      case 'fetchRecommendationKPI':
        return this.fetchRecommendationKPI(prop);
      case 'isInValidPickupSelectionForRecommendation':
        return this.isInValidPickupSelectionForRecommendation(prop.pickupAssignmentType);
      case 'lastRefreshRecommendationTime':
        return this.lastRefreshRecommendationTime;
      case 'isRecommendationRefreshInProgress':
        return this.isRecommendationRefreshInProgress;
      case 'openGeoCodeModel':
        const driverMapHeaderId = `gridHeader_${appConstants.layout.DispatchDriversMap}`;
        this.props.glEventHub?.emit?.(`${driverMapHeaderId}_geocode`, prop.groupId);
        return;
      default:
        break;
    }
  };

  isInValidPickupSelectionForRecommendation = (pickupAssignmentType) => {
    const { selectedPickupsList } = this.props.DispatchStore;
    if (pickupAssignmentType === PICKUP_ASSIGNMENT_TYPE.assignSelected) {
      return !selectedPickupsList.some(
        (pickup) => this.state.formattedPickupRecommendations[pickup.groupId?.toLowerCase()]
      );
    }
    return isEmpty(this.state.formattedPickupRecommendations);
  };

  getPayloadForAssignRecommendedDriver = (pickups) => {
    return pickups.reduce(
      (mappedData, pickup) => {
        const recommendationId = this.getRecommendedDriverDetailsByGroupId(
          pickup.groupId
        )?.driverId;
        if (recommendationId) {
          return pickup.driverId
            ? getPayloadForReAssignedDriver({ payload: mappedData, pickup, recommendationId })
            : getPayloadForAssignedDriver({ payload: mappedData, pickup, recommendationId });
        }
        return mappedData;
      },
      { assignPickupsPayload: [], reassignPickupsPayload: [] }
    );
  };

  assignRecommendations = ({ pickupAssignmentType }) => {
    const { selectedPickupsList, pickupsList } = this.props.DispatchStore;
    let assignPickupDetails = [],
      reassignPickupDetails = [];
    if (pickupAssignmentType === PICKUP_ASSIGNMENT_TYPE.assignSelected) {
      const groupedPickupDetails = createAssignPickupDetails(selectedPickupsList);
      const { assignPickupsPayload, reassignPickupsPayload } =
        this.getPayloadForAssignRecommendedDriver(groupedPickupDetails);
      assignPickupDetails = assignPickupsPayload;
      reassignPickupDetails = reassignPickupsPayload;
    } else {
      const groupedPickupDetails = createAssignPickupDetails(pickupsList);
      const { assignPickupsPayload, reassignPickupsPayload } =
        this.getPayloadForAssignRecommendedDriver(groupedPickupDetails);
      assignPickupDetails = assignPickupsPayload;
      reassignPickupDetails = reassignPickupsPayload;
    }
    const terminalCode = this.props.userData.userProfile.terminal.code;
    const glEventHub = this.props.glEventHub;
    if (reassignPickupDetails.length) {
      let pickupDetails = reassignPickupDetails;
      if (assignPickupDetails.length) {
        pickupDetails = getFormattedPayloadForAssignUnAssignPickups(
          assignPickupDetails,
          reassignPickupDetails
        );
      }
      reassignPickup({
        pickupDetails,
        terminalCode,
        glEventHub,
        DispatchStore: this.props.DispatchStore,
        enqueueSnackbar: this.props.enqueueSnackbar
      });
    } else if (assignPickupDetails.length) {
      assignPickup({
        assignPickupDetails,
        terminalCode,
        glEventHub,
        DispatchStore: this.props.DispatchStore,
        enqueueSnackbar: this.props.enqueueSnackbar
      });
    }
    RMAXLogger.info('AssignRecommendations', {
      pickupAssignmentType,
      assignCount: assignPickupDetails?.length ?? 0,
      reassignCount: reassignPickupDetails?.length ?? 0
    });
  };

  assignPickups = ({ pickupIdList, groupId, recommendedDriverId }) => {
    const assignPickupDetails = [
      { pickupId: pickupIdList, driverId: recommendedDriverId, groupId }
    ];
    assignPickup({
      assignPickupDetails,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      enqueueSnackbar: this.props.enqueueSnackbar
    });
    RMAXLogger.info('AssignRecommendations', {
      pickupAssignmentType: PICKUP_ASSIGNMENT_TYPE.assignIndividual,
      assignCount: assignPickupDetails.length
    });
  };

  reassignPickups = ({ pickupIdList, groupId, driverId, recommendedDriverId }) => {
    const reassignPickupDetails = [
      {
        pickupId: pickupIdList,
        groupId,
        driverIdToUnassign: driverId ?? undefined,
        driverIdToAssign: recommendedDriverId
      }
    ];
    reassignPickup({
      pickupDetails: reassignPickupDetails,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      enqueueSnackbar: this.props.enqueueSnackbar
    });
    RMAXLogger.info('AssignRecommendations', {
      pickupAssignmentType: PICKUP_ASSIGNMENT_TYPE.assignIndividual,
      reassignCount: reassignPickupDetails.length
    });
  };

  refreshRecommendationCell = () => {
    this.gridApi.refreshCells({ columns: [DRIVER_RECOMMENDATION_COL_ID], force: true });
  };

  updateDriverRecommendations = () => {
    this.refreshRecommendationCell();
    clearRecommendationKPICache();
  };

  getRecommendedDriverDetailsByGroupId = (groupId) => {
    return this.state.formattedPickupRecommendations[groupId?.toLowerCase()] ?? null;
  };

  fetchRecommendationKPI = ({ groupId, cancelToken }) => {
    return getDataWithQueryString(
      'PickupRecommendationKPI',
      `groupId=${groupId}&terminalCode=${this.props.userData.userProfile.terminal.code}`,
      { cancelToken }
    ).then((response) => {
      if (response?.status >= 200 && response.status < 400) {
        return {
          data: getFormattedKPIRecommendationData(
            response.data,
            this.props.DispatchStore.routesList
          ),
          success: true
        };
      }
      return {
        data: {},
        success: false
      };
    });
  };

  refreshDuplicatePickups = () => {
    getDataWithDeduplication(
      'GetDuplicatePickups',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((response) => {
        let duplicatePickups = [];
        if (response?.status === 200) {
          duplicatePickups = response.data ?? [];
        }
        this.props.DispatchStore.updateDuplicatePickups(duplicatePickups);
        this.refreshPossibleMergeIcon();
      })
      .catch(() => {});
  };

  openGroupPickupDetailsDialog = (groupId) => {
    const groupPickupDialogBuiltState = buildGroupPickupDialogState(
      groupId,
      this.props.DispatchStore.pickupsList,
      this.props.DispatchStore.currentActiveRoutes
    );
    if (!groupPickupDialogBuiltState) {
      this.props.enqueueSnackbar('Group pickup details not found', {
        variant: 'error'
      });
      return;
    }
    const { pickupInfo, groupMemberPickups, groupBulkEditPickupIds, driverDetails } =
      groupPickupDialogBuiltState;
    const shipmentAPI = 'GetPickupShipments';
    const normalizedGroupId = String(groupId).toUpperCase();
    // Mirror single-pickup dialog: include `driverDetails` plus flattened driver fields for shared `constructRouterState` / pro-details flows.
    this.props.router.navigate(`?groupId=${encodeURIComponent(normalizedGroupId)}`, {
      state: cloneNavigateStateForHistory({
        isGroupPickupDialog: true,
        groupId: normalizedGroupId,
        pickupInfo,
        groupMemberPickups,
        groupBulkEditPickupIds,
        driverDetails,
        shipmentAPI,
        ...(driverDetails || {}),
        isPastPickup: false,
        isPickupHistory: false,
        proImageApiName: 'GetImages',
        terminalCode: this.props.userData?.userProfile?.terminal?.code
      })
    });
  };

  //pastPickupDetails is getting passed only for past pickup flow
  openPickupDetailsDialog = (pickupIdOrPayload, viewHistory = false, pastPickupDetails = null) => {
    const isGroupNavigationPayload =
      pickupIdOrPayload &&
      typeof pickupIdOrPayload === 'object' &&
      !Array.isArray(pickupIdOrPayload) &&
      pickupIdOrPayload.groupId;
    if (isGroupNavigationPayload && this.props.configJSON?.enableBulkEditAndVoid) {
      return this.openGroupPickupDetailsDialog(pickupIdOrPayload.groupId);
    }
    if (isGroupNavigationPayload) {
      return;
    }
    const pickupId = pickupIdOrPayload;
    const selectedPickupData = pastPickupDetails || this.getSelectedPickupData(pickupId);
    if (!selectedPickupData) {
      this.props.enqueueSnackbar('Pickup details not found', {
        variant: 'error'
      });
      return;
    }
    const isPastPickup = Boolean(pastPickupDetails);
    const pickupInfo = cloneDeep(selectedPickupData);
    const driverDetails = isPastPickup
      ? null //for past pickup driverDetails is getting updated in navigate state
      : cloneDeep(
          getDriverStopDetails({
            activeDriverDetails: {
              currentActiveRoutes: this.props.DispatchStore.currentActiveRoutes,
              pickupInfo
            }
          })
        );
    const shipmentAPI = isPastPickup ? '' : 'GetPickupShipments';
    this.props.router.navigate(`?pickupNumber=${selectedPickupData.pickupNumber}`, {
      state: {
        pickupInfo,
        driverDetails,
        shipmentAPI,
        ...(!isPastPickup && driverDetails), //Only active dispatch driver data, for other flow it will be set in navigation state
        isPastPickup,
        isPickupHistory: viewHistory,
        proImageApiName: !isPastPickup ? 'GetImages' : 'StopImages'
      }
    });
  };

  startPickupsRefreshInterval = () => {
    this.pickupsStatusUpdateTimer = setInterval(() => {
      this.props.DispatchStore.updateClosingSoonPickups();
      this.props.glEventHub.emit('ClosingSoonPickupsUpdated');
      // Only refresh cells if not in the middle of group selection
      if (!this.isGroupSelectionInProgress) {
        this.gridApi.refreshCells({ columns: ['pickupNumberList', 'closingSoon'], force: true });
      }
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  getSelectedPickupsDuplicate = (pickupId) => {
    return getDuplicatePickupsByPickupId(this.props.DispatchStore.duplicatePickups, pickupId);
  };

  getClosingSoonPickupTime = (pickupId) => {
    return this.props.DispatchStore.getClosingSoonPickupTime(pickupId);
  };

  getClosingSoonTimeConfig = () => {
    return {
      closingSoonWarningTimeLimit: this.props.configJSON?.closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit: this.props.configJSON?.closingSoonAlertTimeLimit
    };
  };

  handlePossibleMergeClick = (selectedPickupId) => () => {
    this.currentPickupDuplicates = [];
    this.setState({
      mode: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
      selectedPossibleMergePickupId: selectedPickupId?.toLowerCase()
    });
  };

  handleUnGroupPickupClick = (selectedPickups) => () => {
    if (selectedPickups.length > 0) {
      this.setState({
        mode: PICKUP_MANAGEMENT_MODES.UNGROUP_PICKUP,
        selectedGroupPickupData: selectedPickups
      });
    }
  };

  unGroupPickup = (selectedPickups) => {
    const { terminalCode, driverId } = selectedPickups[0];
    const pickupIds = selectedPickups.map((pickup) => pickup.pickupId);
    if (terminalCode && pickupIds.length > 0) {
      const requestObj = {
        terminalCode: terminalCode,
        removedPickupIds: pickupIds,
        assignedDriverId: driverId
      };
      this.setState({
        loadingUnmergePickup: true
      });
      postData('UnGroupPickup', requestObj)
        .then((response) => {
          if (response?.status >= 200 && response.status < 400) {
            return;
          }
          this.handleUnGroupPickupError();
        })
        .catch(() => {
          this.handleUnGroupPickupError();
        });
    }
  };

  handleUnGroupPickupError = () => {
    this.closeUnGroupPickup();
    this.props.enqueueSnackbar('Error occurred while ungrouping pickup', {
      variant: 'error'
    });
  };

  isSelectedPickup = (pickupIds) => {
    if (pickupIds.length > 0 && this.state.selectedGroupPickupData.length > 0) {
      const pickupIdsUppercase = pickupIds.map((id) => id.toUpperCase());
      return this.state.selectedGroupPickupData?.some((pickup) =>
        pickupIdsUppercase?.includes(pickup.pickupId?.toUpperCase())
      );
    }
    return false;
  };

  // Handle group row styling based on selection state and theme
  getGroupRowStyle = (isGroupSelected, theme) => {
    let backgroundColor = 'transparent';
    if (isGroupSelected) {
      backgroundColor =
        theme.themeName === 'modernLight'
          ? '#BAD0E2' // Modern Light theme selection color
          : '#274A6C'; // Modern Dark theme selection color
    }    
    return {
      backgroundColor,
      transition: 'background-color 0.2s ease, border 0.2s ease'
    };
  };

  handleUnmergePickup = (data) => {
    if (
      this.state.mode === PICKUP_MANAGEMENT_MODES.UNGROUP_PICKUP &&
      this.isSelectedPickup(data.unmergedPickupIds || (data.pickupId ? [data.pickupId] : []))
    ) {
      if (data.success) {
        this.props.enqueueSnackbar(
          `Pickup ${this.state.selectedGroupPickupData?.map((pickup) => pickup.pickupNumber).join(', ')} unmerged successfully`,
          {
            variant: 'success'
          }
        );
        this.closeUnGroupPickup();
      } else {
        this.handleUnGroupPickupError();
      }
    }
  };

  refreshPossibleMergeIcon = () => {
    this.gridApi.refreshCells({ columns: ['isMergedPickup'], force: true });
  };


  openPastPickup = () => {
    this.setState({
      isPastPickupOpen: true
    });
  };

  // Entry point: notification click on Pickups grid — set pending and apply filters.
  navigateToToBeReviewedPickup = ({
    pickupId,
    pickupIds,
    alertId,
    clearAllActive = false,
  } = {}) => {
    const idsToSelect = (pickupIds?.length ? pickupIds : pickupId ? [pickupId] : []).filter(
      Boolean
    );
    if (
      !idsToSelect.length ||
      !isActivePickupGridTab(this.props.glContainer, appConstants.gridNames.PickupsGrid)
    ) {
      return;
    }
    const toBeReviewedOption = getToBeReviewedGridFilterOption();
    if (!toBeReviewedOption) return;

    // Clear bell cards only after this grid accepts navigation.
    applyPickupReviewDismissAfterNavigate(this.props.DispatchStore, {
      clearAllActive,
      alertId,
    });

    // Keep all related TBR pickup ids so summary-card click can multi-select.
    this.pendingNavigateToPickupIds = idsToSelect;
    this.pendingNavigateToPickupId = idsToSelect[0];
    this.pendingNavigateFiltersCleared = false;
    const panelReset = this.resetPanelFilterForToBeReviewedNavigation();
    const headerApplied = this.applyToBeReviewedHeaderFilterForNavigation(toBeReviewedOption);
    const waitingForGridUpdate = panelReset || headerApplied;
    if (!waitingForGridUpdate) {
      this.completePendingToBeReviewedNavigation();
    }
  };

  // Reset status-bar panel filter to All so to-be-reviewed rows are not hidden.
  resetPanelFilterForToBeReviewedNavigation = () => {
    if (!isActivePanelFilter(this.state.panelFilter)) return false;
    this.setState({ panelFilter: PICKUP_STATUS.allPickups }, () => {
      this.gridApi?.onFilterChanged?.();
    });
    return true;
  };

  // Apply To Be Reviewed header filter and sync the dropdown.
  applyToBeReviewedHeaderFilterForNavigation = (toBeReviewedOption) => {
    if (isToBeReviewedHeaderFilter(this.state.headerFilter?.value)) return false;
    this.props.DispatchStore.updatePickupsFilter(toBeReviewedOption);
    this.props.glEventHub.emit('pickupsPanelfilterchanged', toBeReviewedOption);
    // Ensure grid state updates even when the dropdown already shows To Be Reviewed.
    this.filterManager.headerFilterChanged({ option: toBeReviewedOption });
    return true;
  };

  // Fallback: clear quick search and column filters that still hide the pickup.
  clearConflictingFiltersForPickupNavigation = () => {
    if (!hasQuickOrColumnFilters(this.state, this.gridApi)) return false;
    if (this.state.quickFilterText?.trim()) {
      this.filterManager.onSearchTextChanged('');
    }
    clearColumnFilters(this.gridApi);
    return true;
  };

  // Clear pending navigation state when done or aborted.
  clearPendingToBeReviewedNavigation = () => {
    this.pendingNavigateToPickupId = null;
    this.pendingNavigateToPickupIds = null;
    this.pendingNavigateFiltersCleared = false;
  };

  // After filters land: expand multi-pickup groups, select exact TBR ids, scroll to newest.
  completePendingToBeReviewedNavigation = () => {
    const pickupIds =
      this.pendingNavigateToPickupIds?.length > 0
        ? this.pendingNavigateToPickupIds
        : this.pendingNavigateToPickupId
          ? [this.pendingNavigateToPickupId]
          : [];
    if (!pickupIds.length || !this.gridApi) return;
    if (!isActivePickupGridTab(this.props.glContainer, appConstants.gridNames.PickupsGrid)) {
      this.clearPendingToBeReviewedNavigation();
      return;
    }

    // One-shot clear of leftover quick/column filters that can still hide rows.
    if (!this.pendingNavigateFiltersCleared && this.clearConflictingFiltersForPickupNavigation()) {
      this.pendingNavigateFiltersCleared = true;
      return;
    }

    this.finishPendingToBeReviewedNavigation(pickupIds);
  };

  // Select exact TBR pickup ids; expand group headers so grouped children can render/select.
  finishPendingToBeReviewedNavigation = (pickupIds) => {
    const ids = (Array.isArray(pickupIds) ? pickupIds : [pickupIds]).filter(Boolean);
    this.clearPendingToBeReviewedNavigation();
    if (!ids.length) return;

    const pickupsList = this.props.DispatchStore.pickupsList || [];
    const flatPickupsList = this.props.DispatchStore.flatPickupsList || [];
    const groupIdsToExpand = new Set();

    ids.forEach((pickupId) => {
      const pickup = findPickupById(flatPickupsList, pickupId);
      const groupId = normalizeGroupId(pickup?.groupId);
      if (!groupId || this.state.expandedGroups.has(groupId)) return;
      // Only multi-pickup groups have a header row; single-in-group rows are always visible.
      const hasGroupHeader = pickupsList.some(
        (row) => isGroupHeaders(row) && normalizeGroupId(row.id) === groupId
      );
      if (hasGroupHeader) {
        groupIdsToExpand.add(groupId);
      }
    });

    this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedPickups', [
      ids.map((id) => id.toLowerCase()),
    ]);

    const applySelection = () => {
      this.selectionManager?.selectPickups?.();
      this.updatePickupManagementIconStatus();
      scrollPickupIntoView(this.gridApi, ids[0]);
    };

    if (!groupIdsToExpand.size) {
      applySelection();
      return;
    }

    this.setState(
      (prevState) => ({
        expandedGroups: [...groupIdsToExpand].reduce(
          (expanded, groupId) => withGroupExpanded(expanded, groupId),
          prevState.expandedGroups
        ),
      }),
      () => {
        // RowData updates with expanded children on this render; defer so AG Grid nodes exist.
        applySelection();
        clearTimeout(this.selectionStateSyncTimer);
        this.selectionStateSyncTimer = setTimeout(applySelection, 0);
      }
    );
  };

  closePastPickup = () => {
    this.setState({
      isPastPickupOpen: false
    });
  };

  openPickupManagement = (eventData) => {
    const isMergePickup = isMergePickupMode(eventData.action);
    if (eventData.action === PICKUP_MANAGEMENT_MODES.UNGROUP_PICKUP) {
      this.handleUnGroupPickupClick(this.props.DispatchStore.selectedPickupsList)();
      return;
    }
    if (isMergePickup) {
      if (eventData.isEditOrCreatePossibleMerge) {
        this.setState({
          mode: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
          selectedPossibleMergePickupId: null
        });
        return;
      }
      this.confirmMergePickup();
    } else {
      const isBulkMode =
        eventData.action === PICKUP_MANAGEMENT_MODES.BULK_EDIT_PICKUP ||
        eventData.action === PICKUP_MANAGEMENT_MODES.BULK_VOID_PICKUP;
      if (isBulkMode && !eventData.skipGroupSelectAll) {
        this.groupDataManager.selectAllPickupsWithSameGroupId();
      }
      this.setState({
        mode: eventData.action
      });
    }
  };

  closePickupManagement = () => {
    if (this.clearBulkEditSelectionOnClose) {
      this.clearBulkEditSelectionOnClose = false;
      this.pickupSelectedOnGrid = false;
      this.props.glEventHub.emit("UpdateDispatchStore", "updateSelectedPickups", [[]]);
      this.gridApi?.deselectAll?.();
      this.selectionManager?.updateGridSelectionState?.();
      this.props.glEventHub.emit(appConstants.Event.PICKUP_SELECTED_GRID, {
        pickupsData: [],
      });
      this.updatePickupManagementIconStatus();
    }
    this.currentPickupDuplicates = [];
    this.pendingEditPickup = false;
    this.pendingEditPickupId = null;
    this.pendingEditPickupAction = null;
    this.setState({
      mode: '',
      selectedPossibleMergePickupId: null,
      openMergeConfirmationDialog: false
    });
  };

  closeUnGroupPickup = () => {
    this.pendingEditPickup = false;
    this.pendingEditPickupId = null;
    this.pendingEditPickupAction = null;
    this.setState({
      mode: '',
      selectedGroupPickupData: null,
      loadingUnmergePickup: false
    });
  };

  onSelectionChanged = (event) => {
    this.selectionManager.onSelectionChanged(event);
  };

  onRowClicked = (event) => {
    this.selectionManager.onRowClicked(event);
  };

  isRowSelectable = (node) => {
    return this.selectionManager.isRowSelectable(node);
  };


  onCellClicked = () => {
    this.pickupSelectedOnGrid = true;
  };

  onRowDataUpdated = () => {
    this.gridApi.refreshCells({ columns: ['pickupNumberList', 'isMergedPickup'], force: true });
    if (this.isRecommendationsEnabled) {
      this.refreshRecommendationCell();
    }
    this.updatePickupManagementIconStatus();

    // Always refresh selection state when row data is updated
    // This ensures individual rows show as selected when groups expand
    clearTimeout(this.selectionStateSyncTimer);
    this.selectionStateSyncTimer = setTimeout(() => {
      this.selectionManager.updateGridSelectionState();
    }, 0);
  };

  onPickupSelectedOnMap = (selectedPickupIdList, refreshDriverSelection = true) => {
    this.selectionManager.onPickupSelectedOnMap(selectedPickupIdList, refreshDriverSelection);
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
    // Ensure context is properly initialized before any cell rendering
    this.groupDataManager.updateGridContext();
    this.selectionManager.selectPickups();
    this.updatePickupManagementIconStatus();
    this.startPickupsRefreshInterval();
    this.resetRecommendation();
  };

  onModelUpdated = () => {
    const isQuickFilterPresent = this.gridApi.isQuickFilterPresent?.();
    const isColumnFilterPresent = this.gridApi.isColumnFilterPresent?.();
    if (
      isColumnFilterPresent ||
      isQuickFilterPresent ||
      this.state.quickFilterText
    ) {
      this.isAnyFilterSet = true;
      const filteredRows = [];
      this.gridApi.forEachNodeAfterFilterAndSort?.((node) => {
        if (node.data && !isGroupHeaders(node.data)) {
          filteredRows.push(node.data);
        }else if (isGroupHeaders(node.data) && !node.data.isExpanded) {
          filteredRows.push(node.data, ...getPickupsInGroup(node.data.id, this.props.DispatchStore.pickupsList));
        }
      });
      const uniqueFilteredRows = uniqBy(filteredRows, (row) =>
        (row.pickupId || row.id)?.toLowerCase()
      );
      this.props.glEventHub.emit("UpdateDispatchStore", "updateFilteredPickups", [
        uniqueFilteredRows,
      ]);
    } else {
      if (this.isAnyFilterSet) {
        this.props.glEventHub.emit("UpdateDispatchStore", "updateFilteredPickups", [
          this.props.DispatchStore.pickupsList,
        ]);
        this.isAnyFilterSet = false;
      }
    }

    if (this.pendingNavigateToPickupId) {
      this.completePendingToBeReviewedNavigation();
    }
  };

  resetGridSelections = () => {
    if (this.state.headerFilter?.value === PICKUPS_GRID_FILTERS.allPickups) {
      return;
    }
    this.gridApi.deselectAll();
    // Clear pending edit flags when resetting selections
    this.pendingEditPickup = false;
    this.pendingEditPickupId = null;
    this.pendingEditPickupAction = null;
    // Group selection state is now computed from pickup selections - no state update needed
  };


  updatePickupManagementIconStatus = () => {
    // Use store data as the single source of truth for selection
    // This ensures consistency across all components and handles group selections correctly
    const selectedPickups = this.props.DispatchStore.selectedPickupsList || [];
    
    this.props.glEventHub.emit(`${this.gridHeaderId}_updatePickupManagementIconStatus`, {
      selectedPickups,
      terminalOffset: this.props.DispatchStore.terminalOffset
    });
  };


  onDoubleClicked = (event) => {
    if (isGroupHeaders(event.data)) {
      if (this.props.configJSON?.enableBulkEditAndVoid) {
        const headerGroupId = event.data?.groupId || event.data?.id;
        if (headerGroupId) {
          this.openGroupPickupDetailsDialog(headerGroupId);
        }
      }
      return;
    }

    this.props.DispatchStore.selectedPickupIdList.length > 0 &&
      this.openPickupDetailsDialog(this.props.DispatchStore.selectedPickupIdList[0]);
  };


  getSelectedPickupData = (selectedPickupId) => {
    const { DispatchStore } = this.props;
    return DispatchStore.getPickupData(selectedPickupId);
  };

  /** Pickup IDs represented by rows currently shown in the grid after filters (group header rows count as their child pickups). */
  getVisiblePickupIdsAfterFilter = () => {
    const visible = new Set();
    if (!this.gridApi?.forEachNodeAfterFilterAndSort) return visible;
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      const d = node?.data;
      if (!d) return;
      if (isGroupedPickups(d) || isSingleInGroupPickups(d)) {
        const pid = d.pickupId || d.id;
        if (pid) visible.add(String(pid).toLowerCase());
      } else if (isGroupHeaders(d) && Array.isArray(d.pickupNumberIdList)) {
        d.pickupNumberIdList.forEach((p) => {
          if (p?.pickupId) visible.add(String(p.pickupId).toLowerCase());
        });
      }
    });
    return visible;
  };

  areBulkPickupIdsFullyVisibleOnGrid = (normalizedIds) => {
    if (!normalizedIds?.length) return false;
    const visible = this.getVisiblePickupIdsAfterFilter();
    if (!visible.size) return false;
    return normalizedIds.every((id) => visible.has(id));
  };

  unassignPickupFromDriver = () => {
    const { pickupId, driverId, groupId } =
      this.props.DispatchStore.selectedPickupIdList.length > 0 &&
      this.getSelectedPickupData(this.props.DispatchStore.selectedPickupIdList[0]);

    unassignPickup({
      pickups: [{ pickupId, groupId }],
      driverId: driverId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      showConfirmation: false
    })
      .then(() => {
        this.closePickupManagement();
      })
      .catch(() => {
        this.props.glEventHub.emit('DispatchEvents', 'HideLoaderDialog', []);
      });
  };

  getSelectedPickupsByIds = () => {
    let duplicatePickupIds = this.props.DispatchStore.selectedPickupIdList;
    if (this.state.selectedPossibleMergePickupId) {
      duplicatePickupIds = getDuplicatePickupsByPickupId(
        this.props.DispatchStore.duplicatePickups,
        this.state.selectedPossibleMergePickupId
      );
    } else if (this.currentPickupDuplicates?.length) {
      return this.currentPickupDuplicates;
    }
    return duplicatePickupIds.map((pickupId) => this.getSelectedPickupData(pickupId));
  };

  getPickupManagementDetailsByMode = (selectedPickupData) => {
    if (this.state.mode === PICKUP_MANAGEMENT_MODES.CREATE_PICKUP) {
      return {
        title: 'Add New Pickup',
        pickupData: null
      };
    }
    if (this.state.mode === PICKUP_MANAGEMENT_MODES.MERGE_PICKUP) {
      const selectedPickups = this.getSelectedPickupsByIds();
      return {
        title: 'Merge Pickup',
        pickupData: selectedPickups.filter(Boolean)
      };
    }
    if (isBulkPickupMode(this.state.mode)) {
      const selectedPickups = this.getSelectedPickupsByIds().filter(Boolean);
      const title = selectedPickups[0]?.shipperName || "";
      return {
        title,
        pickupData: selectedPickups,
      };
    }
    if (this.currentPickupDuplicates.length === 1) {
      selectedPickupData = this.currentPickupDuplicates[0];
    }
    return {
      title: `${selectedPickupData.shipperName} (${selectedPickupData.pickupNumber})`,
      pickupData: selectedPickupData
    };
  };


  editPickup = (pickupIdOrPayload) => {
    if (
      pickupIdOrPayload &&
      typeof pickupIdOrPayload === "object" &&
      !Array.isArray(pickupIdOrPayload) &&
      Array.isArray(pickupIdOrPayload.bulkPickupIds) &&
      pickupIdOrPayload.bulkPickupIds.length > 0
    ) {
      const normalizedIds = [
        ...new Set(
          pickupIdOrPayload.bulkPickupIds.map((id) =>
            String(id || "").toLowerCase()
          )
        ),
      ].filter(Boolean);
      const resolved = normalizedIds
        .map((id) => this.getSelectedPickupData(id))
        .filter(Boolean);
      if (!resolved.length) {
        this.props.enqueueSnackbar("Could not load pickups for edit.", {
          variant: "warning",
        });
        return;
      }
      const allBulkIdsVisibleOnGrid =
        this.areBulkPickupIdsFullyVisibleOnGrid(normalizedIds);

      if (allBulkIdsVisibleOnGrid) {
        // Bulk edit: open management after syncing selection. We intentionally do not use
        // `pendingEditPickup` / `onPickupSelectedOnMap` here — that path is for single-pickup edit
        // and would expand group rows; bulk from Group Info / Driver popup must not expand groups.
        this.clearBulkEditSelectionOnClose = false;
        this.pickupSelectedOnGrid = false;
        this.props.glEventHub.emit("UpdateDispatchStore", "updateSelectedPickups", [
          normalizedIds,
        ]);
        // Sync grid selection to store selection without changing expanded/collapsed state.
        this.selectionManager?.selectPickups?.();
        this.updatePickupManagementIconStatus();
        this.openPickupManagement({
          action: PICKUP_MANAGEMENT_MODES.BULK_EDIT_PICKUP,
          skipGroupSelectAll: true,
        });
        return;
      }

      this.clearBulkEditSelectionOnClose = true;
      this.pendingEditPickup = false;
      this.pendingEditPickupId = null;
      this.pendingEditPickupAction = null;
      this.pickupSelectedOnGrid = false;
      this.props.glEventHub.emit("UpdateDispatchStore", "updateSelectedPickups", [
        normalizedIds,
      ]);
      this.selectionManager?.selectPickups?.();
      this.updatePickupManagementIconStatus();
      this.openPickupManagement({
        action: PICKUP_MANAGEMENT_MODES.BULK_EDIT_PICKUP,
        skipGroupSelectAll: true,
      });
      return;
    }
    const pickupId =
      typeof pickupIdOrPayload === "string" ? pickupIdOrPayload : null;
    if (pickupId) {
      this.pendingEditPickupAction = PICKUP_MANAGEMENT_MODES.EDIT_PICKUP;
      this.pendingEditPickupId = pickupId;
      this.onPickupSelectedOnMap([pickupId]);
      this.pendingEditPickup = true;
    } else {
      this.pendingEditPickupAction = null;
      this.openPickupManagement({ action: PICKUP_MANAGEMENT_MODES.EDIT_PICKUP });
    }
  };

  currentMergePickupClick = (currentPickupDuplicates, isEditOrCreatePossibleMerge = false) => {
    this.currentPickupDuplicates = currentPickupDuplicates;
    this.openPickupManagement({
      action: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
      isEditOrCreatePossibleMerge
    });
  };

  currentEditPickupClick = (currentPickupDuplicates) => {
    this.currentPickupDuplicates = currentPickupDuplicates;
    this.openPickupManagement({ action: PICKUP_MANAGEMENT_MODES.EDIT_PICKUP });
  };

  isUserPreferenceRecommendationSetHidden = () => {
    return this.props.userData.userProfile?.columnPref?.[
      `${appConstants.gridNames.PickupsGrid}_Config`
    ]?.columns?.find((column) => column.headerName === RECOMMENDATION_HEADER_NAME)?.hide;
  };

  getPickupManagementKey = (selectedPickupData) => {
    let currentDuplicateKey = null;
    if (this.currentPickupDuplicates?.length) {
      // pick pickupId key other than current selected pickupId
      currentDuplicateKey =
        this.currentPickupDuplicates.find(
          (pickup) => pickup.pickupId?.toLowerCase() !== selectedPickupData.pickupId?.toLowerCase()
        ) ?? 'possible-duplicate';
    }
    return (
      currentDuplicateKey ||
      selectedPickupData.pickupId?.toLowerCase() ||
      this.state.selectedPossibleMergePickupId?.toLowerCase() ||
      'pickup-selection-removed'
      /* fallback when selected pickup get removed from store due to change in pickup terminal or selected pickup is no longer duplicate to each other,
         The component remount every timer there is change in pickup terminal due to the key we are using here.
       */
    );
  };


  renderPickupManagement = (selectedPickupData, mode, selectedPossibleMergePickupId) => {
    return (
      <PickupManagement
        key={this.getPickupManagementKey(selectedPickupData)}
        handleClose={this.closePickupManagement}
        mode={mode}
        glEventHub={this.props.glEventHub}
        {...this.getPickupManagementDetailsByMode(selectedPickupData)}
        selectedPossibleMergePickupId={selectedPossibleMergePickupId}
        editPickup={this.currentEditPickupClick}
        mergePickup={this.currentMergePickupClick}
        disableEnforceFocus={this.props.router.searchParams.has('customerCode')}
        resetGridSelections={this.resetGridSelections}
        open
      />
    );
  };

  renderModeBasedContent = (selectedPickupData, mode, selectedPossibleMergePickupId,selectedGroupPickupData) => {
    const { loadingUnmergePickup } = this.state;
    if (!mode) {
      return null;
    }
    switch (mode) {
      case PICKUP_MANAGEMENT_MODES.UNGROUP_PICKUP:
        if (!selectedGroupPickupData) {
          return null;
        }
        return (
          <CustomConfirmationDialog
            title="Unmerge Pickup"
            cancelButtonLabel="Cancel"
            confirmButtonLabel={
              selectedGroupPickupData[0]?.driverId ? 'Unassign & Unmerge' : 'Unmerge'
            }
            onConfirm={() => this.unGroupPickup(selectedGroupPickupData)}
            onCancel={this.closeUnGroupPickup}
            mode="danger"
            loading={loadingUnmergePickup}
            children={
              <div>
                {selectedGroupPickupData[0]?.driverId
                  ? `This pickup group is already assigned to a driver, removing selected pickups will unassign them from Driver ${selectedGroupPickupData[0]?.driverName}. Do you want to continue?`
                  : `Selected pickups will be released back into the grid as independent. Do you want to continue?`}
              </div>
            }></CustomConfirmationDialog>
        );

      case PICKUP_MANAGEMENT_MODES.VOID_PICKUP:
        if (selectedPickupData?.driverId) {
          return (
            <CustomConfirmationDialog
              title="Assigned pickup selected to void."
              cancelButtonLabel="Cancel"
              confirmButtonLabel="Unassign"
              onConfirm={this.unassignPickupFromDriver}
              onCancel={this.closePickupManagement}>
              <ConfirmationDialogContent isGroupedPickups={isGroupedPickups(selectedPickupData)} />
            </CustomConfirmationDialog>
          );
        }
      case PICKUP_MANAGEMENT_MODES.BULK_VOID_PICKUP:
        if (selectedPickupData?.driverId) {
          return (
            <CustomConfirmationDialog
              title="Assigned group pickups selected to void."
              cancelButtonLabel="Cancel"
              confirmButtonLabel="Unassign Group"
              onConfirm={this.unassignPickupFromDriver}
              onCancel={this.closePickupManagement}>
              <ConfirmationDialogContent
                isGroupedPickups={isGroupedPickups(selectedPickupData)}
                isBulkVoidPickup
              />
            </CustomConfirmationDialog>
          );
        }
      // Fall through to default case
      case PICKUP_MANAGEMENT_MODES.MERGE_PICKUP:
        if (this.enablePickupGrouping && this.state.openMergeConfirmationDialog) {
          return (
            <CustomConfirmationDialog
              title="Merge Pickup Not Allowed"
              mode="danger"
              confirmButtonLabel="OK"
              onConfirm={this.closePickupManagement}>
              <div>
                Selected pickups are more than one mile apart. Please select pickups that are less
                than one mile apart.
              </div>
            </CustomConfirmationDialog>
          );
        }
        // Render PickupManagement when merge confirmation dialog is not open
        return this.renderPickupManagement(selectedPickupData, mode, selectedPossibleMergePickupId);
      case PICKUP_MANAGEMENT_MODES.EDIT_PICKUP:
      case PICKUP_MANAGEMENT_MODES.CREATE_PICKUP:
      default:
        // Skip rendering PickupManagement if EDIT_PICKUP mode and no selected pickup data
        if (mode === PICKUP_MANAGEMENT_MODES.EDIT_PICKUP && !selectedPickupData) {
          return null;
        }
        return this.renderPickupManagement(selectedPickupData, mode, selectedPossibleMergePickupId);
    }
  };

  render() {
    const { mode, selectedPossibleMergePickupId, selectedGroupPickupData } = this.state;
    const { DispatchStore, theme, glContainer } = this.props;

    // Get raw pickup data and process it with grouping
    const groupedPickups = this.groupDataManager.getGridData();

    // Apply visibility logic for group expansion based on rowType
    const pickups = this.groupDataManager.getVisibleRows(groupedPickups, this.state.expandedGroups);

    // Update grid context without calling refreshCells during render
    this.gridContext = {
      ...this.gridContext,
      expanded: this.state.expandedGroups,
      toggle: this.groupDataManager.toggleGroup,
      onGroupClick: this.selectionManager.handleSelection,
      isGroupSelected: this.selectionManager.isGroupSelected,
      getZoneValue: getZoneValue
    };
    const selectedPickupData = this.pendingEditPickupId
      ? this.getSelectedPickupData(this.pendingEditPickupId)
      : DispatchStore.selectedPickupIdList.length > 0 &&
        this.getSelectedPickupData(DispatchStore.selectedPickupIdList[0]);
    return (
      <div>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={pickups}
          onCellClicked={this.onCellClicked}
          onRowClicked={this.onRowClicked}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged}
          isRowSelectable={this.isRowSelectable}
          onCellDoubleClicked={this.onDoubleClicked}
          doesExternalFilterPass={this.filterManager.doesExternalFilterPass}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.filterManager.constructStatusBar(filteredData)}
              filterGridData={this.filterManager.panelFilterChanged}
            />
          )}
          isExternalFilterPresent={() =>
            Boolean(
              this.state.headerFilter.value || this.state.panelFilter || this.state.quickFilterText
            )
          }
          externalFilter={true}
          layoutContainer={glContainer}
          // Remove quickFilterText since we're using doesExternalFilterPass
          deltaRowDataMode={true}
          // Use AG-Grid's built-in sorting with simplified post-sort logic
          suppressSorting={false}
          postSortRows={this.enablePickupGrouping ? postSortGroupedPickupsRows : undefined}
          onRowDataUpdated={this.onRowDataUpdated}
          onModelUpdated={this.onModelUpdated}
          getRowId={(params) => {
            // Ensure unique IDs for all row types using the id field
            return params.data.id;
          }}
          getRowStyle={(params) => {
            if (isGroupHeaders(params.data)) {
              const isGroupSelected = this.selectionManager.selectedGroups.has(params.data.id);
              return this.getGroupRowStyle(isGroupSelected, theme);
            }
            return {};
          }}
          showErrorMessage={DispatchStore.pickupsGridMessage}
          context={this.gridContext}
          suppressCellFocus={true}
          animateRows={true}
          suppressRowVirtualisation={pickups?.length < 300}
        />

        {this.renderModeBasedContent(selectedPickupData, mode, selectedPossibleMergePickupId,selectedGroupPickupData)}
        {this.state.isPastPickupOpen && (
          <PastPickup
            open={this.state.isPastPickupOpen}
            handleClose={this.closePastPickup}
            glEventHub={this.props.glEventHub}
          />
        )}
      </div>
    );
  }
}

// Apply Material-UI styles and other HOCs
// const StyledComponent = StyledGroupPickup();

export default compose(
  withUserProfile,
  withAppConfig,
  withFeatureFlags,
  withSnackbar,
  withTheme(),
  withRouter
)(GroupPickup);
